<template>
  <!-- 水表控制 -->
  <div class="FilesManage">
    <div class="con">
      <div class="left-tree">
        <elAreaTree :dataList='dataList'></elAreaTree>
      </div>
      <div class="right-table">
        <div class="content">
          <div class="Files-top">
            <div class="ic-left">
              <span>水表操控</span>
            </div>
            <div class="btns">
              <el-button type="primary" @click="quyu" style="height:32px;margin:0px 15px">按所选中片区发送</el-button>
              <el-button type="primary" @click="biao" class="last-el-button">按所选中的表发送</el-button>
            </div>
          </div>

          <div class="Files-table" :style="{'height':heights+'px'}">
            <el-table :data="tableData" border stripe style="width: 100%" :max-height="heights - 20"
              @selection-change="handleSelectionChange">
              <template slot="empty">
                <span class="noData">
                  <img src="../../assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column type="selection" width="44" align="center">
              </el-table-column>
              <el-table-column label="序号" width="90" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="deviceNo" label="设备号" width="404"> </el-table-column>
              <el-table-column label="表类型" width="405">
                <template #default="{row}">
                  <span>{{row.meterRunType==1?'预付费表':'普通表'}}</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" align="center">
                <template #default="{row}">
                  <!-- <span>{{row.state232?'开闸':'关闸'}}</span> -->
                  <div class="state-row open-state" v-if="row.state232">
                    <span></span>开闸
                  </div>
                  <div class="state-row close-state" v-else>
                    <span></span>关闸
                  </div>
                </template>
              </el-table-column>

            </el-table>
          </div>
          <div class="divider-line"></div>
          <div class="paging">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
              :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>

        </div>
      </div>
    </div>
    <!-- 输入密码 -->
    <el-dialog v-dialogDrag title="密码" :visible.sync="centerDialogVisible" width="30%" center
      :close-on-click-modal='false'>
      <span><el-input placeholder="请输入密码" v-model="input" show-password @change="submit"></el-input></span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增修改 -->
    <el-dialog width="800px" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div style="display: flex;" class="dialog">
        <el-form :model="temp" ref="temp" :rules="rules" label-width="100px" style="padding-top: 10px; display: flex;
        flex-wrap: wrap;" :inline="true">
          <el-form-item label="表编号:" prop="value" v-if="dialogStatus == 'add'">
            <el-cascader v-model="value" :options="[treeData]" :props="{ children: 'next', label:'name',value:'id'}"
              @change="handleChange" :show-all-levels="false"></el-cascader>
          </el-form-item>
          <el-form-item label="表底数:" prop="meterBase">
            <el-input v-model="temp.meterBase" type="number"></el-input>
          </el-form-item>
          <el-form-item label="抄表日期:" prop="deductionFeeDay">
            <el-select v-model="temp.deductionFeeDay" placeholder="请选择">
              <el-option v-for="item in 31" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="表类型:" prop="meterType">
            <el-select v-model="temp.meterType" placeholder="请选择" @change="typeListFn">
              <el-option v-for="item in typeList" :key="item.id" :label="item.typeName" :value="item.typeName">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="支付类型:">
            <el-select v-model="temp.meterRunType" placeholder="请选择">
              <el-option label="预付费电表" value="1"> </el-option>
              <el-option label="普通电表" value="2"> </el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
  import elAreaTree from '@/components/module/newTree/elAreaTree.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      elAreaTree
    },
    data () {
      var checkAge=(rule,value,callback) => {
        console.log(this.value,1111)
        if(!this.value) {
          return callback(new Error('请选择设备'));
        } else {
          callback();
        }

      };
      return {
        input: '',//密码
        centerDialogVisible: false,//输入密码弹窗
        areaName: '',//区域名称
        value: '',
        treeData: {},
        areaId: '',//区域id
        heights: document.getElementById('app').clientHeight-240,//屏幕高度 - 导航栏高度
        seraname: "",
        tableData: [],
        loading: false,
        total: 0,
        currentPage: 1,
        currentSize: 15,
        //弹窗
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        //新增修改对象
        temp: {
          "meterRunType": 1,
          'meterReadingType': "water",
        },
        //星号必填
        rules: {
          value: [
            {validator: checkAge,trigger: 'change'}
          ],
          meterBase: [
            {required: true,message: '请输入表底数',trigger: 'blur'}
          ],
          deductionFeeDay: [
            {required: true,message: '请输入抄表日期',trigger: 'blur'}
          ],
          meterType: [
            {required: true,message: '请输入表类型',trigger: 'blur'}
          ],
        },
        roleOptions: [],
        typeList: [],
        paramsed: {},//控制水表参数
      };
    },

    computed: {
      deviceDataList () {
        // 尚未被配置为抄表的设备筛选
        var tree=this.$store.deviceStore.getters.getControlDeviceTree
        return tree
      },
      dataList () {
        var data=this.$store.unitStore.getters.getAreaTree
        return isempty(data)? []:[deviceList(data)]
      },
      nowArea () {
        var data=this.$store.cacheStore.state.setBuilding
        this.areaId=data.id
        this.areaName=data.label
        return data
      }

    },

    mounted () {
      this.getList()
      this.getTypeList() //获取表类型方式
      if(this.deviceDataList) {
        this.treeData=this.deviceDataList
      }

    },
    watch: {
      nowArea (v) {
        this.areaId=v.id
        this.getList()
        this.areaName=v.label
      }

    },


    methods: {
      submit () {
        if(this.input) {
          this.paramsed.password=hex_md5(this.input);
          this.centerDialogVisible=false;
          this.ceshi();
        } else {
          this.$message({showClose: true,message: '请输入密码',type: 'error'});
        }

      },
      // 按所选中的表发送
      biao () {
        if(!this.roleOptions.length) {
          this.$message({showClose: true,message: '请勾选数据',type: 'error'});
          return
        }
        this.paramsed={
          "areaId": "",
          "deviceNo": [],
          "endState": 0,
          "password": ""
        }
        this.roleOptions.map(v => {
          this.paramsed.deviceNo.push(v.deviceNo)
        })

        this.centerDialogVisible=true;
        this.input='';
      },
      // 按所选中片区发送
      quyu () {
        if(!this.areaId) {
          this.$message({showClose: true,message: '请选择区域',type: 'error'});
          return
        }
        this.paramsed={
          "areaId": this.areaId,
          "deviceNo": [],
          "endState": 0,
          "password": ""
        }
        this.centerDialogVisible=true;
        this.input='';
      },
      // 多选列表
      handleSelectionChange (v) {
        this.roleOptions=v;
        console.log(v);
      },
      //水表管理->控制水表
      ceshi () {
        var data=this.paramsed;
        request({url: "/water/controlMeter.do",method: "post",data}).then(res => { //负荷设备数 
          console.log(res,'水表管理->控制水表');
          if(res.code==200) {
            this.$message({showClose: true,message: '操作成功',type: 'success'});
          }
        })
      },
      // 导出
      exportWaterMeter () {
        if(!this.areaId) {
          this.$message({showClose: true,message: '请选择区域',type: 'error'});
          return
        }
        // areaId
        var params={
          areaId: this.areaId,
          fileName: this.areaName,
        }
        // console.log(,'11');
        window.open(DWSystemSetting.baseURL+'/water/exportWaterMeter?areaId='+this.areaId+'&fileName='+this.areaName,"_blank");
      },
      //  选择设备号
      handleChange (value) {
        this.temp.deviceNos=[value[value.length-1]]
        // console.log(value);
        // console.log(this.temp.deviceNos);
      },
      // 选择表类型
      typeListFn (v) {
        console.log(v,'111');
      },
      // 点击树形返回
      getSchoolName (v) {
        console.log(v,'vv');
        this.areaId=v.id;
        this.areaName=v.label;
        this.getList()
      },
      //获取表类型方式
      getTypeList () {
        request({url: "/meterType/findMeterType",method: "post"}).then(res => { //负荷设备数
          if(res.code==200) {
            this.typeList=res.data
          }
        })

      },
      // 添加弹窗
      add_ed (v) {
        this.dialogStatus='add';
        this.value='';//清空设备号
        this.temp={
          "meterRunType": 1,
          'meterReadingType': "water",
        };
        if(this.areaId) {
          this.dialogVisible=true;
        } else {
          this.$message({showClose: true,message: '请选择区域',type: 'error'});
        }


        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            var data=this.temp;
            data.areaId=this.areaId;
            request({url: "/water/saveWaterMeter.do",method: "post",data}).then(res => { //负荷设备数 
              console.log(res,'1111111');
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;//关闭弹窗
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })

            // saveIcCard(this.temp).then(res => {

            // })
          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp;
            data.areaId=this.areaId;
            request({url: "/water/saveWaterMeter.do",method: "post",data}).then(res => { //负荷设备数  
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;//关闭弹窗
                this.$message({showClose: true,message: '编辑成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('编辑失败');
                }
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        console.log(v,'v');
        this.temp=JSON.parse(JSON.stringify(v))
        this.value=[this.temp.deviceNo];//设备号  
        this.temp.deviceNos=[this.temp.deviceNo];//设备号 
        // this.temp.deviceNos=[20]
        this.dialogVisible=true;

        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
      //单个删除
      del_fn (row) {
        this.$confirm(`是否删除 ${row.deviceNo}号设备数据`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // var params=new FormData();
          // params.append("id",row.deviceNo);
          var params={deviceNos: row.deviceNo}
          request({
            url: "/water/deleteWaterMeter",method: "delete",params
          }).then(res => { //负荷设备数 

            if(res.code==200) {
              this.getList();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              if(res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error('删除失败');
              }
            }
          })

        }).catch(() => {
          // ...
        });
      },
      //批量导入
      saveExcel_fn (file) {
        let data=new FormData();
        data.append("file",file.raw);
        data.append("areaId",this.areaId);
        //  
        request({
          url: "/water/importWaterMeter",method: "post",data
        }).then(res => { //负荷设备数 
          if(res.code==200) {
            this.getList()
            this.$message({showClose: true,message: res.data,type: 'success'});
          } else {
            res.message? this.$message.error(res.message):this.$message.error('添加失败')

          }
        })


      },
      //获取数据
      getList () {
        var params={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          'areaId': this.areaId,
          'meterReadingType': 'water',
          deviceNo: this.seraname
        }
        this.loading=true
        request({url: "/water/getControlMeter.do",method: "get",params}).then(res => { //负荷设备数 
          this.loading=false
          if(res.code==200) {
            var d=res.data.dataResult.dataList;
            var a=[]
            for(const key in d) {
              if(d[key]) {
                d[key].map(v => {
                  a.push(v)
                })
              }
            }
            this.tableData=a;
            this.total=res.data.numberResult.total;
          }
        })
      },
      //分页功能 
      handleSizeChange (val) {
        this.currentSize=val;
        this.getList()
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.getList()
      }
    },
    filters: {
      //费率类型 ELECTRIC(电)  WATER(水) GAS(气)
      energyType (val) {
        if(val=='ELECTRIC') {
          return "电"
        } else if(val=='WATER') {
          return "水"
        } else {
          return "气"
        }
      },
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .FilesManage {
    display: flex;

    .con {
      width: 100%;
      height: 100%;
      display: flex;
    }

    .left-tree {
      width: 3rem;
      height: 100%;
      flex-shrink: 0;
      overflow: hidden;
      background-color: #fff;
      padding: 12px;
      padding-top: 20px;
      box-sizing: border-box;
      margin-right: 8px;
    }



    .right-table {
      width: 100%;
      flex: 1;
      background-color: #fff;
      overflow: hidden;

      .Files-top {
        margin: 20px;
      }

      .Files-table {
        margin: 0px 20px;

        /deep/.el-table th {
          background-color: #F3F8FF;
          color: #999999;
          border-right: 1px solid #E6E6E6;
          padding: 10px 0px;
          font-weight: bold;
        }

        /deep/.el-table td {
          padding: 1px 0px;
          height: 44px;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .state-row {
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          display: inline-block;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          margin-right: 10px;
          position: relative;
          top: -1px;
          border: 4px solid transparent;
        }
      }

      .open-state {
        color: #0DAE88;

        span {
          background-color: #0DAE88;
          border-color: #B0FFED;
        }
      }

      .close-state {
        color: #FF1D1D;

        span {
          background-color: #FF1D1D;
          border-color: #FFD7D7;
        }
      }


      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        margin-right: 15px;
      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    .dialog {
      /deep/.el-input__inner {
        width: 217px;
      }
    }

    /deep/.el-input__inner {
      height: 34px;
      line-height: 34px;
    }

    /deep/.el-input__icon {
      line-height: 34px;
    }

  }

  /deep/.el-tree-node__content {
    width: 3rem;
  }
</style>